
































import { Component, Vue, Prop } from 'vue-property-decorator';
import depositService from '@/services/deposit-services';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import { DepositModel } from '@/models/deposit'
import { APP_CONFIG } from '@/config/app-config';

@Component({
    components: {
        ConfirmModal
    }
})
export default class DepositDetailFooter extends Vue {
    private isConfirm = false;
    private isLoading = false;
    private isCancelOrder = false;
    private modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';

    @Prop({default: null})
    private deposit!: DepositModel;
    
    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }
    private async complainOrder() {
        this.$router.push({ name: 'deposit-complain', params: { orderId: this.deposit.id.toString(), orderType: '2' } });
    }
    private async cancelOrder(ret) {
        const dataRequest =  {
            Status: 1,
            CancelReason: ret.CancelReason
        };
        const result = await depositService.updateDeposit(this.deposit.id, dataRequest);
        
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Hủy đơn hàng thành công!',
            });
            this.$emit('eventCancelOrder', { status: 1 });
        }
    }

    private async cancelConfirm() {
        this.modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';
        this.isConfirm = true;
        this.isCancelOrder = true;
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }

    private onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.cancelOrder(eventData.ret);
        }
    }
}
